const KegSizeEndpoint = {
  index (product_id, company_id) {
    return {
      url: `/keg_sizes?product_id=${product_id}&company_id=${company_id}`,
      method: 'GET'
    }
  }
}

export default KegSizeEndpoint



// WEBPACK FOOTER //
// ./src/persistence/KegSizeEndpoint.js